import { Action } from "@ngrx/store";

export const SET_SOFTWARE_VALUE = '[softwares] Set Software';
export const UNSET_SOFTWARE_VALUE = '[softwares] Unset Software';
export const UPDATE_SOFTWARE_VALUE = '[softwares] Update Software';

export class SetSoftwareValue implements Action {
    readonly type = SET_SOFTWARE_VALUE;
    constructor(public softwareChosen: string) { }
}

export class UnsetSoftwareValue implements Action {
    readonly type = UNSET_SOFTWARE_VALUE;
}

export class UpdateSoftwareValue implements Action {
    readonly type = UPDATE_SOFTWARE_VALUE;
    constructor(public softwareChosen: string) { }
}

export type SoftwaresActions = SetSoftwareValue | UnsetSoftwareValue | UpdateSoftwareValue;
